import {
  IMeasureInput,
  MeasureType,
  MeasureVersionType,
} from '../../../apollo/graphqlSchema';
import { ICohortRow } from '../../../../redux/slices/oldBuilder';
import { prepareRollingControlInput, prepareSimpleMeasureInput } from './utils';

/**
 * A function will prepare measure for Measure cohort condition.
 *
 * By design, we can have:
 * 1). Simple measure that can be: basic or named.
 * 2). Compound measure: only named one.
 */
export const prepareCohortMeasureInput = (
  cohortRow: ICohortRow,
  schemaId: string,
): IMeasureInput => {
  const type = cohortRow.type as MeasureType;

  if (type === MeasureType.Compound && cohortRow?.measureId) {
    return {
      type,
      compound: {
        basicMeasure: null,
        namedMeasure: {
          versionId: cohortRow.measureId,
        },
        type: MeasureVersionType.Named,
      },
      simple: null,
      rollingControl: null,
      format: null,
    };
  }

  return {
    type,
    compound: null,
    simple: prepareSimpleMeasureInput(
      {
        row: {
          measureId: cohortRow?.measureId ?? '',
          fn: cohortRow?.fn,
          eventConditions: cohortRow?.eventConditions,
          percentile: cohortRow.percentile,
        },
        rowIndex: 0,
        measureFormula: null,
      },
      schemaId,
    ),
    rollingControl: prepareRollingControlInput(
      cohortRow?.measureRollingControl,
    ),
    format: null,
  };
};
